/// <reference path="../templates/third-party-selector.template.html" />
(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.directive('thirdPartySelector', ['ThirdPartyEnum', '$filter', ThirdPartySelectorFn]);

    /* thirdParty directive */
    function ThirdPartySelectorFn(ThirdPartyEnum, $filter) {

        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/syncsettings/templates/third-party-selector.template.html',
            scope: {
                item: '='
            }
        };

        return directive;

        function link(scope, element, attrs) {
            //init
            scope.thirdPartyInterfaces = [];

            activate();

            // select
            scope.select = function (thirdParty) {
                scope.item.vmThirdParty = thirdParty;
            };

            /* activation work */
            function activate() {
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.OfficeSuite365);
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.CielComm);
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.IntroCare);
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.CliniNET);
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.DentalAdmin);
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.Medibase);
                scope.thirdPartyInterfaces.push(ThirdPartyEnum.EyeFile);

                // set default first element
                if (typeof scope.item.thirdParty !== 'undefined') {
                    scope.item.vmThirdParty = $filter('filter')(scope.thirdPartyInterfaces, { value: scope.item.thirdParty }, true)[0];
                } // if
                else {
                    // default
                    scope.item.vmThirdParty = scope.thirdPartyInterfaces[0];
                }

            }
        }
    }

})();